<template>
    <v-breadcrumbs
        divider="-"
        :items="breadcrumbItems"
    />
</template>
<script>
export default{
    name: 'BreadCrumbs',
    computed: {
        breadcrumbItems() {
            let _breadcrumbs = []
            let routeBreadcrumbs = this.$route.meta.breadcrumbs
            for (let bredcrumb of routeBreadcrumbs){
                if (bredcrumb.title === 'undefined' || bredcrumb.href == '')
                    continue
                _breadcrumbs.push({
                    'title': bredcrumb.title,
                    'href':bredcrumb.href})
                if (bredcrumb.href === 'undefined' || bredcrumb.href == '')
                    _breadcrumbs[_breadcrumbs.length()-1]['active'] = false
            }
            return _breadcrumbs
        }
    },
    methods: {
        getRouteParams(paramName){
            if (this.$props.routeParams === 'undefined')
                return  paramName
            if (this.$props.routeParams.paramName === 'undefined')
                return  paramName
            return this.$props.routeParams.paramName
        },
        getRouteTitle(titleName){
            if (this.$props.routeTitles === 'undefined')
                return  titleName
            if (this.$props.routeTitles.titleName === 'undefined')
                return titleName
            return this.$props.routeTitles.titleName
        },
        getRouteHref(hrefName){
            if (this.$props.hrefName === 'undefined')
                return hrefName
            if (this.$props.hrefParams.hrefName === 'undefined')
                return hrefName
            return this.$props.hrefParams.hrefName
        }
    }
}
</script>